import { gql } from 'apollo-angular';

const GET_OFFER_MIX_RESULTS = gql`
  query GetOfferMixResults($offerId: Long!) {
    offerMixResults(offerId: $offerId) {
      buyer {
        id
        name
      }
      commitmentType
      createdBy
      createdDate
      currentSellerSpendLevel {
        absoluteDollars
        absoluteUnits
        dollarMarketShare
        spendLevelType
        unitMarketShare
      }
      id
      lastModifiedBy
      lastModifiedDate
      offer {
        id
        name
      }
      seller {
        id
        name
      }
      tierType
      tiers {
        tier {
          id
          name
          description
          tierType
          order
          spendLevelType
          dollarMarketShare
          absoluteDollars
          unitMarketShare
          absoluteUnits
        }
        offerMixTierResults {
          id
          bestSavings
          worstSavings
          offerMixType
          usePrimaryCrosses
          commitmentType
          ignoreAttainability
          attainability
          supplementalData {
            minNumberOfConversions
            bestPlannedSpend
            bestPlannedSpendWithSeller
            bestPlannedSpendCovered
            bestSpendCoveragePct
            bestSellerSpendCoveragePct
          }
          offerMixResultId
          rfpScopedBestSavingsPct
          rfpScopedWorstSavingsPct
          benchmarks {
            id
            offerMixTierResultId
            benchmarkPct
            name
            savings
            coverage
          }
        }
      }
    }
  }
`;

export default GET_OFFER_MIX_RESULTS;
